import { render, staticRenderFns } from "./event-editor.vue?vue&type=template&id=0b08f41a&"
import script from "./event-editor.vue?vue&type=script&lang=js&"
export * from "./event-editor.vue?vue&type=script&lang=js&"
import style0 from "./event-editor.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports